import type { ReactNode } from 'react';

import wallpaper from '../../../assets/images/Auth/wallpaper.jpg';
import { AuthTestimonialCard } from '../AuthTestimonialCard';
import { AuthTrustBar } from '../AuthTrustBar';

const BRAND_NAME = 'this+that';

const stylesheet = {
  root: 'relative overflow-hidden flex flex-col h-full p-10',
  wallpaper: 'absolute inset-0 h-full w-full object-cover pointer-events-none',
  radialGlow: 'absolute pointer-events-none',
  dotGrid: 'absolute inset-0 pointer-events-none opacity-5',
  content: 'relative z-10 flex flex-col h-full',
  wordmark: 'font-bold text-white tracking-[-0.015em]',
  testimonialWrapper: 'mt-auto mb-6',
};

const PANEL_GRADIENT_STYLE = {
  background:
    'linear-gradient(150deg, var(--color-panel-a), var(--color-panel-b))',
} as const;

const RADIAL_GLOW_STYLE = {
  width: 620,
  height: 620,
  top: -160,
  right: -160,
  background:
    'radial-gradient(circle, rgba(255,255,255,0.18), transparent 70%)',
} as const;

const DOT_GRID_STYLE = {
  backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)',
  backgroundSize: '22px 22px',
} as const;

const WORDMARK_STYLE = {
  fontSize: 32,
  fontWeight: 800,
  letterSpacing: '-0.015em',
} as const;

export function AuthBrandPanel(): ReactNode {
  return (
    <div className={stylesheet.root} style={PANEL_GRADIENT_STYLE}>
      <img className={stylesheet.wallpaper} src={wallpaper} alt="" />
      <div
        className={stylesheet.radialGlow}
        style={RADIAL_GLOW_STYLE}
        aria-hidden="true"
      />
      <div
        className={stylesheet.dotGrid}
        style={DOT_GRID_STYLE}
        aria-hidden="true"
      />
      <div className={stylesheet.content}>
        <span className={stylesheet.wordmark} style={WORDMARK_STYLE}>
          {BRAND_NAME}
        </span>
        <div className={stylesheet.testimonialWrapper}>
          <AuthTestimonialCard />
        </div>
        <AuthTrustBar />
      </div>
    </div>
  );
}
